import React from 'react'
import styles from './logout.module.css'
import { useAuth } from '../../utilities/auth/auth';
import { useNavigate } from 'react-router-dom';

const Logout = ({ onClose, session }) => {
    const { logout } = useAuth();
    const navigate = useNavigate()

    const handleLogout = async () => {
        await logout();
        navigate('/login', { replace: true });
    };
    return (
        <div className={styles.logoutcontainer}>
            <h2>
                {session ? 'Session expired!' : 'Logout!'}
            </h2>
            <div className={styles.optioncontainer}>
                <span>
                    {!session ? 'Are you sure?' : `please login again.`}
                </span>
                <div className={styles.buttonContainer}>
                    <button className={styles.yes} onClick={handleLogout}>{!session ? 'Yes' : 'Login'}</button>
                    {!session && <button className={styles.cancel} onClick={onClose}>Cancel</button>}
                </div>
            </div>
        </div>
    )
}

export default Logout